import * as RadixPopover from '@radix-ui/react-popover';
import { memo } from 'react';

export type ComboboxTriggerProps = RadixPopover.PopoverTriggerProps;

export const ComboboxTrigger = memo((props: RadixPopover.PopoverTriggerProps) => {
  return <RadixPopover.Trigger data-testid="COMBOBOX_TRIGGER" {...props} />;
});

ComboboxTrigger.displayName = 'ComboboxTrigger';
